const activeClass = 'form-block__border_active'

export const toggleBorder = (el, type) => {
  if (type && type === 'show') {
    el.classList.add(activeClass)
  }
  else {
    el.classList.remove(activeClass)
  }
}
